import React, { useCallback } from 'react';
import { compose } from 'ramda';
import { useDispatch } from 'react-redux';
import { defaultProps, lifecycle, withHandlers, withProps, withState } from 'recompose';
import { I18n } from 'js/components/common/I18n';
import { Icon as IconCommon } from 'js/components/common/Icon';

import { hideNotificationAction } from './store/actions';
import style from './index.scss';

export const NotificationIcon = ({ Icon, iconType }) => Icon
    ? <div className={style.icon}>{Icon}</div>
    : iconType
        ? <div className={style.icon}>
            <IconCommon type={iconType} />
        </div>
        : null;

export const Notification = ({ Icon, iconType, children, message, tKey, registerChild, clsName, className, handleClick }) => (
    <div ref={registerChild} className={`${style.notification} ${className} ${clsName}`}>
        <div className={style.container} onClick={handleClick}>
            <NotificationIcon {...{ Icon, iconType }} />

            <span className={style.message}>
                    {tKey && <I18n tKey={tKey} /> || message}
                </span>
        </div>
        {children}
    </div>
);

export default compose(
    withProps(() => {
        const dispatch = useDispatch();

        return {
            hideNotification: useCallback(id => dispatch(hideNotificationAction(id)), [dispatch])
        };
    }),
    defaultProps({
        enableAutoHide: true,
        message: '',
        tKey: '',
        onClose: () => {},
        onClick: () => {},
        onHide: () => {},
        displayTime: 5
    }),
    withState('clsName', 'setClsName', style.slideIn),
    withHandlers(({ hideNotification }) => ({
        animationEnd: ({ id, enableAutoHide, onHide, clsName }) => () => {
            if (enableAutoHide && clsName === style.slideOut) {
                onHide();
                hideNotification(id);
            }
        }
    })),
    withHandlers(({ hideNotification }) => {
        let notificationRef;

        return {
            registerChild: () => ref => notificationRef = ref,

            subscribeAnimationEnd: ({ animationEnd }) => () => {
                notificationRef.addEventListener('animationend', animationEnd);
            },
            unsubscribeAnimationEnd: ({ animationEnd }) => () => {
                notificationRef.removeEventListener('animationend', animationEnd);
            },

            handleClick: ({ id, onClick, onClose }) => (event) => {
                onClick(event);
                onClose();
                hideNotification(id);
            }
        };
    }),
    lifecycle({
        componentDidMount() {
            const { index, displayTime, enableAutoHide, setClsName, subscribeAnimationEnd } = this.props;
            const time = displayTime * 1000 + index * 10;

            if (enableAutoHide) {
                this.timer = setTimeout(() => {
                    setClsName(style.slideOut);
                }, time);
            }

            subscribeAnimationEnd();
        },
        componentWillUnmount() {
            clearTimeout(this.timer);

            this.props.unsubscribeAnimationEnd();
        }
    })
)(Notification);
